import React from "react";

const About = () => (
  <div className="container">
    <h2>About Page</h2>
  </div>
);

export default About;
